if (!window.Eurus.loadedScript.has('truncate-text.js')) {
  window.Eurus.loadedScript.add('truncate-text.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.data('xTruncateText', () => ({
        truncateEl: "",
        truncateInnerEl: "",
        truncated: false,
        truncatable: false,
        label: "",
        expanded: false,
        load(truncateEl) {
          const truncateRect = truncateEl.getBoundingClientRect();
          truncateEl.style.setProperty("--truncate-height", `${truncateRect.height}px`);
        },
        setTruncate(element) {
          if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) {
            this.truncated = true;
            this.truncatable = true;
            this.expanded = false;
          } else {
            this.truncated = false;
            this.truncatable = false;
            this.expanded = true;
          }
        },
        open(el, newLabel) {
          const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
          this.expanded = true;
          this.label = newLabel;
          if (truncateEl.classList.contains('truncate-expanded')) {
            this.truncated = true;
          } else {
            const truncateInnerEl = truncateEl.querySelector('.truncate-inner');
            window.requestAnimationFrame(() => {
              const truncateInnerRect = truncateInnerEl.getBoundingClientRect();
              truncateEl.style.setProperty("--truncate-height-expanded", `${truncateInnerRect.height}px`);
              truncateEl.classList.add('truncate-expanded');
            });
            this.truncated = false;
          }
        },
        close(el, newLabel, isQuickview = false, isImageComparison = false) {
          this.label = newLabel;
          const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
          const isInViewport = () => {
            const rect = truncateEl.getBoundingClientRect();
            return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.xViewport.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.xViewport.innerWidth || document.documentElement.clientWidth))
          }
          this.truncated = true;
          if (!isInViewport() && !isQuickview) {
            if (isImageComparison) {
              this.$nextTick(() => {
                truncateEl.closest('.x-block-header').scrollIntoView({ behavior: "smooth", block: "center", container: "nearest" })
              })
            } else {
              const scrollPosition = truncateEl.getBoundingClientRect().top + window.scrollY - 500 ;
              window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
              });
            }
            truncateEl.style.transition = 'none'
            setTimeout(() => {
              truncateEl.style.transition = ''
            }, 1000)
          }
          truncateEl.classList.remove('truncate-expanded');
          this.expanded = false;
        }
      }));
    })
  })
}

/* ------------------------------------------------------------------
 * Klaviyo Back-in-Stock inline signup (added 18 Jul 2026 by Claude)
 * Replaces Klaviyo's popup button (which Eurus's duplicate add-to-cart
 * forms broke anyway) with an inline email pill on sold-out product
 * pages: bold "Notify me when back in stock" label + email input with
 * a pink Notify Me! button, styled to match the theme. Submits
 * directly to Klaviyo's client back-in-stock API (fires the
 * "Subscribed to Back in Stock" metric that the sorter flow uses).
 * Safe to remove if Klaviyo or the theme handles this natively.
 * ---------------------------------------------------------------- */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var style = document.createElement('style');
  style.id = 'klaviyo-bis-fix-style';
  style.textContent = '#klaviyo-bis-button-container{display:none !important}' +
    '#luluwags-bis-inline{margin-top:14px;font-family:Helvetica,Arial,sans-serif}' +
    '#luluwags-bis-inline .lw-label{font-size:16px;font-weight:700;color:#000;margin-bottom:8px}' +
    '#luluwags-bis-inline .lw-pill{position:relative;width:100%}' +
    '#luluwags-bis-inline .lw-pill input{width:100%;box-sizing:border-box;border:1px solid #000;border-radius:100px;padding:17px 145px 17px 22px;font-size:14px;font-family:Helvetica,Arial,sans-serif;outline:none;background:#fff;color:#000}' +
    '#luluwags-bis-inline .lw-pill button{position:absolute;right:5px;top:5px;bottom:5px;border-radius:100px;background:#ff1c6d;color:#f4f1ed;border:0;padding:0 26px;font-weight:700;font-size:14px;font-family:Helvetica,Arial,sans-serif;cursor:pointer}' +
    '#luluwags-bis-inline .lw-pill button:disabled{opacity:0.6;cursor:default}' +
    '#luluwags-bis-inline .lw-msg{font-size:13px;margin-top:7px;font-weight:700;color:#d02020}' +
    '#luluwags-bis-inline .lw-success{font-size:16px;font-weight:700;color:#000;padding:14px 0}';
  document.head.appendChild(style);
  var getCompanyId = function () {
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/);
      if (m) return m[1];
    }
    return 'QP3Bzn';
  };
  var submitBis = function (box) {
    var input = box.querySelector('input');
    var btn = box.querySelector('button');
    var msg = box.querySelector('.lw-msg');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      return;
    }
    msg.textContent = '';
    btn.disabled = true;
    btn.textContent = '...';
    var form = box.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var variantId = idInput ? idInput.value : '';
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + getCompanyId(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } } } })
    }).then(function (r) {
      if (r.status === 202 || r.status === 409) {
        box.innerHTML = '<div class="lw-success">You&#39;re all set! We&#39;ll email you the second it&#39;s back &mdash; before anyone else hears about it.</div>';
      } else {
        msg.textContent = 'Something went wrong — please try again.';
        btn.disabled = false;
        btn.textContent = 'Notify Me!';
      }
    }).catch(function () {
      msg.textContent = 'Something went wrong — please try again.';
      btn.disabled = false;
      btn.textContent = 'Notify Me!';
    });
  };
  var buildBox = function () {
    var box = document.createElement('div');
    box.id = 'luluwags-bis-inline';
    box.innerHTML = '<div class="lw-label">Notify me when back in stock</div>' +
      '<div class="lw-pill"><input type="email" placeholder="Enter your email" autocomplete="email"><button type="button">Notify Me!</button></div>' +
      '<div class="lw-msg"></div>';
    box.querySelector('button').addEventListener('click', function () { submitBis(box); });
    box.querySelector('input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitBis(box); }
    });
    return box;
  };
  var fix = function () {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var f = null;
    for (var i = 0; i < forms.length; i++) {
      var sec = forms[i].closest('[id^="shopify-section"]');
      if (!sec || sec.id.indexOf('__main') === -1) continue;
      if (forms[i].getBoundingClientRect().width < 200) continue;
      f = forms[i];
      break;
    }
    if (!f) return;
    var atc = f.querySelector('button.add_to_cart_button');
    var soldOut = !!atc && (atc.disabled || atc.hasAttribute('disabled'));
    var box = document.getElementById('luluwags-bis-inline');
    if (!soldOut) {
      if (box) box.style.display = 'none';
      return;
    }
    if (!box) box = buildBox();
    var row = null;
    for (var j = 0; j < f.children.length; j++) {
      var cls = String(f.children[j].className || '');
      if (f.children[j].id !== 'luluwags-bis-inline' && cls.indexOf('flex') !== -1) { row = f.children[j]; break; }
    }
    if (row) {
      if (box.parentElement !== f || box.previousElementSibling !== row) {
        row.insertAdjacentElement('afterend', box);
      }
    } else if (box.parentElement !== f) {
      f.appendChild(box);
    }
    if (box.style.display === 'none') box.style.display = '';
  };
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    fix();
    if (tries > 60) clearInterval(timer);
  }, 500);
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fix();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();